"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commonLinks = void 0;
exports.commonLinks = {
    NAVER_BOOKING_CUSTOMER_SERVICE_CENTER: `https://help.naver.com/service/11713/category/bookmark?lang=ko`,
    MYPLACE_CUSTOMER_SERVICE_CENTER: `https://help.naver.com/service/19485/category/bookmark?lang=ko`,
    ALL_SERVICE: 'https://www.naver.com/more.html',
    NAVER_BOOKING_TERMS_OF_SERVICE: 'https://booking.naver.com/policy',
    NAVER_MAPS_TERMS_OF_SERVICE: 'https://pages.map.naver.com/agree-term/ends/web/agree-detail-mapsvc?lng=ko',
    MYPLACE_REVIEW_POLICY: 'https://m.place.naver.com/my/policy/visitorReview',
    PRIVACY_RULES: 'https://policy.naver.com/rules/privacy.html',
    NAVER: 'https://m.naver.com',
    NAVER_CORP: 'https://navercorp.com',
    NMAP_MY_APP_SCHEME: 'nmap://map?tab=myplace',
};
